import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { IncompleteBookingsResponseSchema } from "../schemas/dashboardV2Schemas";

const API_VERSION = 'v4';

export type IncompleteBookingType = 'all' | 'missing_room_type' | 'missing_rate_plan' | 'missing_room';

interface UseDashboardIncompleteBookingsParams {
    property_id?: string;
    type?: IncompleteBookingType;
    search?: string;
    page?: number;
    per_page?: number;
}

const useDashboardIncompleteBookings = ({ property_id, type = 'all', search, page = 1, per_page = 6 }: UseDashboardIncompleteBookingsParams) => {
    return useQuery({
        queryKey: ['dashboard-incomplete-bookings', property_id, type, search, page, per_page],
        queryFn: async () => {
            const response = await privateApi.get(`/${API_VERSION}/dashboard/bookings/incomplete`, {
                params: { property_id, type, search: search || undefined, page, per_page }
            });
            const validationResult = IncompleteBookingsResponseSchema.safeParse(response.data);
            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid Dashboard Incomplete Bookings data format");
            }
            return validationResult.data;
        },
        enabled: !!property_id,
        retry: import.meta.env.VITE_MAX_RETRY ? parseInt(import.meta.env.VITE_MAX_RETRY as string) : 1,
        refetchOnWindowFocus: false,
    });
};

export default useDashboardIncompleteBookings;
